import { render, staticRenderFns } from "./personal-br-report.vue?vue&type=template&id=0c804905&scoped=true"
import script from "./personal-br-report.vue?vue&type=script&lang=js"
export * from "./personal-br-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c804905",
  null
  
)

export default component.exports